
import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key';

if (import.meta.env.VITE_SUPABASE_URL === undefined || import.meta.env.VITE_SUPABASE_ANON_KEY === undefined) {
    console.error("Supabase Keys Missing in environment!");
}

const isNative = Capacitor.isNativePlatform();

// Singleton pattern for Supabase Client
export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        // ✅ FIX: Disable detectSessionInUrl on native platforms
        // In the Android WebView loading humhena.com, the URL hash detection
        // interferes with session restoration and causes the auth to hang.
        detectSessionInUrl: !isNative,
        // ✅ FIX: Use a stable storage key to prevent session conflicts
        storageKey: 'hh-auth-token',
        // ✅ FIX: Set a shorter timeout so auth calls don't hang forever
        flowType: 'implicit',
    }
});

// ⛔️ SECURITY: Service role key REMOVED from client bundle.
// Admin operations (e.g. deleting auth users) MUST be done via
// Supabase Edge Functions or a backend server.
// The service_role key should NEVER be exposed in client-side code.
export const supabaseAdmin = null;
